{
  "basis": {
    "core": "Protected basis",
    "coreHint": "DMW's own basis tooling, which every project inherits. It changes only with DMW's releases; only administrators open it.",
    "inherited": "Inherits the DMW basis",
    "inheritedHint": "Set up with the project and moved to each newer DMW basis with DMW's releases; the project's own items extend it.",
    "inheritedRelease": "DMW basis {{release}}",
    "update": "Update available"
  },
  "chosen": "Current",
  "create": {
    "name": "Name",
    "next": "Once it is created, it becomes your project and its Documents open.",
    "submit": "Create project",
    "title": "New project"
  },
  "emptyForAdministrator": "There are no projects yet. Create the first one with “New project…”.",
  "emptyForMember": "You are not a member of any project yet. Ask a project administrator to add you.",
  "emptyForProjectCreator": "You are not a member of any project yet. Create one with “New project…”, or ask a project administrator to add you.",
  "invitation": {
    "copyLink": "Copy the invitation link",
    "groups": "Groups",
    "issued": "Invitation for {{email}}, valid until {{expiresAt}}. Send this link to them yourself:",
    "link": "Invitation link",
    "shownOnce": "The link is shown only now. Whoever opens it can create the account, so send it only to the person invited."
  },
  "members": {
    "add": {
      "chosen": "Adds {{name}} ({{emailHint}}).",
      "field": "Name or email",
      "help": "Type a name to find someone who has an account here, or an email address to invite someone new.",
      "invite": "Invite by email",
      "submit": "Add",
      "suggestions": "Accounts that match"
    }
  },
  "menu": {
    "allProjects": "All projects…",
    "choose": "Choose a project",
    "issues": "Issues",
    "label": "Project",
    "newProject": "New project…",
    "settings": "Settings",
    "settingsOf": "Settings of {{project}}",
    "switch": "Switch to"
  },
  "needed": {"action": "Go to projects", "title": "Choose a project first"},
  "picker": {"choose": "Choose a project…", "label": "Project"},
  "settings": {
    "danger": {
      "confirm": "Delete project",
      "confirmMessage_one": "The project leaves every list, and nobody can open it any more, its own administrators included. For {{count}} day, an administrator can restore it as it was.",
      "confirmMessage_other": "The project leaves every list, and nobody can open it any more, its own administrators included. For {{count}} days, an administrator can restore it as it was.",
      "confirmTitle": "Delete {{project}}?",
      "delete": "Delete this project",
      "deleteHint_one": "It disappears for everyone. Administrators can restore it for {{count}} day; after that they can erase it for good.",
      "deleteHint_other": "It disappears for everyone. Administrators can restore it for {{count}} days; after that they can erase it for good.",
      "title": "Danger zone"
    },
    "export": {
      "gitBundle": "Git bundle",
      "hint": "Download what this project publishes, or the whole project. Data releases are made here or on the Data model page.",
      "latestRelease": "Latest data release",
      "title": "Download",
      "wholeProject": "The whole project"
    },
    "members": {"person": "Person", "throughGroup": "through {{group}}"},
    "name": "Project name",
    "rules": {
      "fromDefaults": "The installation's defaults when the project was created ({{at}}): {{rules}}",
      "history": "Rule history",
      "installationMergesSystemChangesHint": "When a DMW release moves projects to a new process ontology, DMW merges that change itself. Off: the change waits for this project's curators, and no Run starts here until they merge it.",
      "lastChange": "{{rule}}: changed by {{name}}, {{at}}: “{{reason}}”",
      "names": {
        "installation_merges_system_changes": "DMW merges its own system changes",
        "merge_rules": "Who may merge their own change",
        "new_member_role": "Default group when adding people",
        "personal_skills_in_shared_threads": "Personal skills in shared Runs",
        "pinning_projects": "Projects that may pin this library",
        "publish_to_researchspace": "Publish data releases to ResearchSpace",
        "release_roles": "Who may make data releases",
        "server_key_groups": "Who may use the server's API keys"
      },
      "otherAuthors": "Other authors",
      "pinningProjectOther": "Unavailable project",
      "pinningProjectsDefaultsHint": "On: a new project starts with an empty list, so nobody can pin it as a library until its administrators list projects.",
      "pinningProjectsHint": "Off: whoever can read this library may pin it into any project where they may propose changes. On: only the projects listed here may add a pin or move it to another version. Pins already in place keep their version and keep working.",
      "pinningProjectsOnly": "Only the projects listed here may pin this project as a library",
      "publishToResearchSpaceHint": "Data releases can then be published to the installation's ResearchSpace, where the project gets its own graphs and pages. Switching it off takes the project's pages out; its published graphs stay. Applies once an administrator has connected ResearchSpace.",
      "secondCurator": "Tools and skills with code need a second curator",
      "title": "Rules"
    },
    "secondCurator": {
      "allowed": "Never",
      "never": "Always",
      "only_when_alone": "Once the project has other members",
      "only_without_other_curator": "When someone else curates them"
    },
    "tabs": {
      "access": "Access",
      "general": "General",
      "history": "History",
      "label": "Project settings",
      "rules": "Rules"
    },
    "title": "Settings of {{project}}"
  },
  "title": "Projects"
}
